module.exports = __webpack_public_path__ + "static/media/admin-cash-register.eefc16fe.svg";